import { MdmRole } from "./MdmRole";

type PoliciesType = {
  RequireAdminRole: MdmRole[];
  RequireAdminNetworkRoles: MdmRole[];
  RequireAdminRiskmanagerRoles: MdmRole[];
  RequireAdminNetworkLaunchRoles: MdmRole[];
  RequireAdminNetworkRiskLaunchRoles: MdmRole[];
  RequireAdminReadOnlyNetworkRiskLaunch: MdmRole[];
  RequireCalculationTriggerRole: MdmRole[];
  RequireReadOnlyRole: MdmRole[];
};
export const AuthorizationPolicies: PoliciesType = {
  RequireAdminRole: ["admin"],
  RequireAdminNetworkRoles: ["admin", "networkplanner"],
  RequireAdminRiskmanagerRoles: ["admin", "riskmanager"],
  RequireAdminNetworkLaunchRoles: ["admin", "networkplanner", "launchteam"],
  RequireAdminNetworkRiskLaunchRoles: ["admin", "networkplanner", "riskmanager", "launchteam"],
  RequireAdminReadOnlyNetworkRiskLaunch: [
    "admin",
    "readonlyuser",
    "networkplanner",
    "riskmanager",
    "launchteam",
  ],
  RequireCalculationTriggerRole: ["calculationtrigger"],
  RequireReadOnlyRole: ["readonlyuser"],
};
